import type { FC } from "react";
import { motion } from "framer-motion";
import classes from "./Offers.module.scss";
import { useTranslation } from "react-i18next";

export const Offers: FC = () => {
	const { t } = useTranslation();
	return (
		<div className={classes.wrapper}>
			<h2 className={classes.title}>{t("translation.offers.title")}</h2>
			<span className={classes.text}>
				{t("translation.offers.description")}
			</span>
			<span className={classes.get}>{t("translation.offers.get")}</span>
			<div className={classes.content}>
				<div className={classes.experience}>
					<h3 className={classes.experience__title}>
						{t("translation.offers.experience")}
					</h3>
					<span className={classes.description}>
						{t("translation.offers.experience-text")}
					</span>
				</div>

				<motion.img
					className={classes.image}
					src="images/gamepad-1.png"
					alt=""
					animate={{
						y: [-10, 10, -10],
					}}
					transition={{
						duration: 5,
						repeat: Infinity,
						repeatType: "reverse",
					}}
				/>

				<div className={classes.potential}>
					<h3 className={classes.potential__title}>
						{" "}
						{t("translation.offers.potential")}
					</h3>
					<span className={classes.description}>
						{t("translation.offers.potential-text")}
					</span>
				</div>
			</div>
			<span className={classes.footer}>{t("translation.offers.footer")}</span>
		</div>
	);
};
